import React, { useContext } from 'react'
import { IconX } from '@tabler/icons-react'
import { useTranslation } from 'react-i18next'
import { CButton } from 'app/components/Common'
import { View, Text } from 'styles/reactnative'
import { ThemeContext } from 'theme/ThemeProvider'

interface IProps {
	closeModal?: () => void
}
const ProfileEditHeader = ({ closeModal }: IProps) => {
	const { textw } = useContext(ThemeContext).theme.COLORS
	const { t } = useTranslation()
	return (
		<View
			style={{
				flexDirection: 'row',
				justifyContent: 'space-between',
				paddingLeft: 0,
				paddingRight: 0,
			}}>
			<Text size={16} style={{ marginTop: 10 }}>
				{t('profileEdit')}
			</Text>
			<CButton
				icon={<IconX size={16} color={textw} />}
				style={{
					padding: 3,
					borderRadius: 50,
				}}
				onClick={() => {
					closeModal && closeModal()
				}}
			/>
		</View>
	)
}

export default ProfileEditHeader
